export const IRANIAN_WOMEN_CATEGORIES = [
    { name: 'همه حوزه‌ها', id: '' },
    { name: 'هنر', id: 'art' },
    { name: 'علم', id: 'science' },
    { name: 'سیاست و جامعه', id: 'politics-and-society' },
    { name: 'ادبیات', id: 'literature' },
    { name: 'آموزش', id: 'education' },
    { name: 'پزشکی', id: 'medicine' },
    { name: 'کسب‌‌وکار', id: 'business' },
    { name: 'محیط زیست', id: 'environment' },
    { name: 'ورزش', id: 'sport' },
]

export const IRANIAN_WOMEN_CAROUSEL = {
    containerWidth: { mobile: 390, desktop: 896 },
    slideSpacing: { mobile: -130, desktop: -320 },
    perView: { mobile: 3.6, desktop: 5 },
    scaledSizes: {
        mobile: [184, 140, 100],
        desktop: [280, 200, 140, 100],
    },
    maxVisibleSideCount: { mobile: 2, desktop: 3 },
    skeletonSlideCount: { mobile: 5, desktop: 7 },
    perViewFormula: {
        min: 3,
        mobile: { visibleSideMultiplier: 1.3, offset: 1 },
        desktop: { visibleSideMultiplier: 0.4, offset: 3.8 },
    },
}
